import {
  Link,
  useLoaderData,
} from "react-router-dom";
import * as API from "../services/isi";


export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getIsiByID(params.isiId);
}


export function IsiItem() {
  const isi = useLoaderData();

  const isiResp = isi.meta?.isiResp;
  const isiFecha = isi.meta?.isiFecha;
  const isiPreg001a = isi.meta?.isiPreg001a;
  const isiPreg001b = isi.meta?.isiPreg001b;
  const isiPreg001c = isi.meta?.isiPreg001c;
  const isiPreg002 = isi.meta?.isiPreg002;
  const isiPreg003 = isi.meta?.isiPreg003;
  const isiPreg004 = isi.meta?.isiPreg004;
  const isiPreg005 = isi.meta?.isiPreg005;

  return (
    <>
    <div id="content">
      {isi.length === 0 ? (
        <div>Cargando...</div>
      ) : (
      <form id="formUpdatelement">
        <fieldset id="disabledContainer" disabled="disabled">
        <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='isiResp'>Responsable</label>
              <div className='control'>
                <input
                  className='input'
                  id='isiResp'
                  required
                  type='text'
                  readOnly
                  value={isiResp}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='isiFecha'>Fecha visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='isiFecha'
                  required
                  type='date'
                  readOnly
                  value={isiFecha}
                />
              </div>
            </div>
          </div>
          <h3>Cuestionario ISI</h3>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='isiPreg001a'>
                1 a. En las últimas dos semanas, indique el nivel de GRAVEDAD en
                la dificultad para quedarse dormido/a
              </label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='isiPreg001a'
                    required
                    name='isiPreg001a'
                    value={isiPreg001a}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='0'>Nada</option>
                    <option value='1'>Leve</option>
                    <option value='2'>Moderado</option>
                    <option value='3'>Grave</option>
                    <option value='4'>Muy grave</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='isiPreg001b'>
                1 b. En las últimas dos semanas, indique el nivel de GRAVEDAD en
                la dificultad para permanecer dormido/a
              </label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='isiPreg001b'
                    required
                    name='isiPreg001b'
                    value={isiPreg001b}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='0'>Nada</option>
                    <option value='1'>Leve</option>
                    <option value='2'>Moderado</option>
                    <option value='3'>Grave</option>
                    <option value='4'>Muy grave</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='isiPreg001c'>
                1 c. En las últimas dos semanas, indique el nivel de GRAVEDAD en
                la dificultad para despertarse demasiado temprano
              </label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='isiPreg001c'
                    required
                    name='isiPreg001c'
                    value={isiPreg001c}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='0'>Nada</option>
                    <option value='1'>Leve</option>
                    <option value='2'>Moderado</option>
                    <option value='3'>Grave</option>
                    <option value='4'>Muy grave</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='isiPreg002'>
                2. ¿Cuán SATISFECHO / INSATISFECHO está con su patrón de sueño
                actual?
              </label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='isiPreg002'
                    required
                    name='isiPreg002'
                    value={isiPreg002}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='0'>Muy satisfecho</option>
                    <option value='1'>Algo satisfecho</option>
                    <option value='2'>Satisfecho</option>
                    <option value='3'>Algo insatisfecho</option>
                    <option value='4'>Muy insatisfecho</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='isiPreg003'>
                3. ¿En qué medida considera que su problema de sueño INTERFIERE
                con su funcionamiento diario (por ejemplo, cansancio durante el
                día, capacidad para realizar las tareas cotidianas / trabajo,
                concentración, memoria, estado de ánimo, etc.)?
              </label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='isiPreg003'
                    required
                    name='isiPreg003'
                    value={isiPreg003}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='0'>Nada</option>
                    <option value='1'>Un poco</option>
                    <option value='2'>Algo</option>
                    <option value='3'>Mucho</option>
                    <option value='4'>Muchísimo</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='isiPreg004'>
                4. ¿En qué medida cree que los demás SE DAN CUENTA de su
                problema de sueño por lo que afecta a su calidad de vida?
              </label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='isiPreg004'
                    required
                    name='isiPreg004'
                    value={isiPreg004}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='0'>Nada</option>
                    <option value='1'>Casi nada</option>
                    <option value='2'>Algo</option>
                    <option value='3'>Mucho</option>
                    <option value='4'>Muchísimo</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='isiPreg005'>
                5. ¿Cuán PREOCUPADO / ANGUSTIADO está por su actual problema de
                sueño?
              </label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='isiPreg005'
                    required
                    name='isiPreg005'
                    value={isiPreg005}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='0'>Nada</option>
                    <option value='1'>Un poco</option>
                    <option value='2'>Algo</option>
                    <option value='3'>Mucho</option>
                    <option value='4'>Muchísimo</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

      </fieldset>
      </form>
      )}
    </div>
    <div id="actions">
      <Link className="button is-link" to={`edit`}>Editar</Link>
    </div>
    </>
  );
}
